import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Notifications() {
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: 'order',
      title: 'تم شحن طلبك',
      message: 'طلبك رقم ORD-2024-002 في الطريق إليك',
      time: 'منذ ساعة',
      read: false,
      icon: 'ri-truck-fill',
      color: 'from-blue-500 to-blue-600'
    },
    {
      id: 2,
      type: 'offer',
      title: 'عرض خاص لك!',
      message: 'خصم 30% على جميع الإلكترونيات لمدة محدودة',
      time: 'منذ 3 ساعات',
      read: false,
      icon: 'ri-price-tag-3-fill',
      color: 'from-orange-500 to-red-500'
    },
    {
      id: 3,
      type: 'order',
      title: 'تم توصيل طلبك',
      message: 'طلبك رقم ORD-2024-001 تم توصيله بنجاح',
      time: 'منذ يوم',
      read: true,
      icon: 'ri-checkbox-circle-fill',
      color: 'from-green-500 to-green-600'
    },
    {
      id: 4,
      type: 'payment',
      title: 'تم استلام الدفع',
      message: 'تم استلام دفعة بقيمة 899 ر.س بنجاح',
      time: 'منذ يومين',
      read: true,
      icon: 'ri-money-dollar-circle-fill',
      color: 'from-purple-500 to-purple-600'
    },
    {
      id: 5,
      type: 'product',
      title: 'منتج جديد متاح',
      message: 'تم إضافة منتجات جديدة في فئة الإلكترونيات',
      time: 'منذ 3 أيام',
      read: true,
      icon: 'ri-shopping-bag-fill',
      color: 'from-pink-500 to-pink-600'
    }
  ]);

  const markAsRead = (id: number) => {
    setNotifications(notifications.map(notif => 
      notif.id === id ? { ...notif, read: true } : notif
    ));
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map(notif => ({ ...notif, read: true })));
  };

  const deleteNotification = (id: number) => {
    setNotifications(notifications.filter(notif => notif.id !== id));
  };

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 pb-20" dir="rtl">
      {/* Header */}
      <div className="fixed top-0 w-full bg-white/80 backdrop-blur-lg shadow-sm z-50">
        <div className="px-4 py-3 flex items-center justify-between">
          <Link to="/profile" className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-2xl text-gray-800"></i>
          </Link>
          <div className="text-center">
            <h2 className="text-lg font-bold text-gray-800">الإشعارات</h2>
            {unreadCount > 0 && (
              <p className="text-xs text-blue-600">{unreadCount} إشعار جديد</p>
            )}
          </div>
          {unreadCount > 0 && (
            <button 
              onClick={markAllAsRead}
              className="text-sm text-blue-600 font-medium"
            >
              قراءة الكل
            </button>
          )}
          {unreadCount === 0 && <div className="w-10"></div>}
        </div>
      </div>

      {/* Notifications List */}
      <div className="pt-20 px-4">
        {notifications.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20">
            <div className="w-32 h-32 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-notification-line text-6xl text-blue-500"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">لا توجد إشعارات</h3>
            <p className="text-gray-600">ستظهر إشعاراتك هنا</p>
          </div>
        ) : (
          <div className="space-y-3">
            {notifications.map((notif) => (
              <div
                key={notif.id}
                onClick={() => markAsRead(notif.id)}
                className={`bg-white rounded-2xl p-4 shadow-sm transition-all duration-300 ${
                  !notif.read ? 'border-r-4 border-blue-500' : ''
                }`}
              >
                <div className="flex gap-4">
                  <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${notif.color} flex items-center justify-center flex-shrink-0`}>
                    <i className={`${notif.icon} text-white text-xl`}></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-start justify-between mb-1">
                      <h3 className={`text-sm font-bold ${!notif.read ? 'text-gray-800' : 'text-gray-600'}`}>
                        {notif.title}
                      </h3>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          deleteNotification(notif.id);
                        }}
                        className="w-6 h-6 flex items-center justify-center text-gray-400 hover:text-red-500 transition-colors"
                      >
                        <i className="ri-close-line text-lg"></i>
                      </button>
                    </div>
                    <p className="text-sm text-gray-600 mb-2">{notif.message}</p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-gray-400">{notif.time}</span>
                      {!notif.read && (
                        <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 w-full bg-white shadow-lg border-t border-gray-100 z-50">
        <div className="grid grid-cols-5 h-16">
          <Link to="/" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-home-line text-xl"></i>
            <span className="text-xs">الرئيسية</span>
          </Link>
          <Link to="/explore" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-search-line text-xl"></i>
            <span className="text-xs">استكشف</span>
          </Link>
          <Link to="/cart" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors relative">
            <i className="ri-shopping-cart-line text-xl"></i>
            <span className="text-xs">السلة</span>
            <span className="absolute top-1 right-1/2 translate-x-3 w-5 h-5 bg-gradient-to-r from-red-500 to-pink-500 text-white text-xs font-bold rounded-full flex items-center justify-center">3</span>
          </Link>
          <Link to="/favorites" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-heart-line text-xl"></i>
            <span className="text-xs">المفضلة</span>
          </Link>
          <Link to="/profile" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-user-line text-xl"></i>
            <span className="text-xs">حسابي</span>
          </Link>
        </div>
      </nav>
    </div>
  );
}
